<template>
  <div
    class="hold-transition login-bg theme-default">
    <div class="login-logo-mobile d-block d-sm-none">
                  <img :src="getImage('logo.svg')" alt="Carnival Internet">
                </div>
    <div class="login-container">
            <div class="login-img">
                <img :src="getImage('login-bg.png')" alt="Carnival Internet" />
            </div>

            <!-- /.login-logo -->
            <div class="login-box-body">
              <router-link class="back-link" :to="{name: 'Login'}">
            <i class="fas fa-angle-left"></i> Back to login
          </router-link>
               <div class="login-logo d-none d-sm-block">
                    <a href="https://stage-site.carnival.com.bd/admin">
                        <span class="logo-lg">
                            <img :src="getImage('logo.svg')" alt="Carnival Internet">
                        </span>
                    </a>
                </div>
                <h2>Forgot Password</h2>

                <div class="overlay text-center" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <form @submit.prevent="forget_pass()" method="POST" novalidate>
        <div class="form-group">
          <label class="control-label">Email</label>
          <input type="text" id="email" name="email" v-model.trim="user.email"
                 class="form-control" placeholder="email"
                 v-validate="'required'"
                 :class="{'has-error' : errors.has('email')}">
          <div class="help text-danger" v-show="errors.has('email')">
            {{ errors.first('email') }}
          </div>  
        </div>
        <div class="form-group">
          <div class="response-alert"></div>
        </div>

        <button type="submit" class="btn btn-common btn-block btn-login">Forgot Password
        </button>
      </form>

            </div>
            <!-- /.login-box-body -->
        </div>
    <!-- e -->
  </div>
</template>
<style>
.v-toaster .v-toast.v-toast-error{
  /* background-color: red !important;
  border-color: red !important; */
    color: #721c24;
    background-color: #f8d7da !important;
    border-color: #f5c6cb !important;
}

.v-toaster .v-toast.v-toast-success{
  /* background-color: red !important;
  border-color: red !important; */
  color: #fff;
  background-color: #28a745 !important;
  border-color: #23923d !important;
}

</style>
<style scoped>
</style>
<script>
import GuestLayout from '@/components/layouts/GuestLayoutComponent.vue';
import axios from 'axios';

export default {
  metaInfo() {
    return {
      title: 'Forgot Password | Dotlines',
      meta: [
        {
          name: 'description',
          content: 'The app built by Dotlines that is simply a framework'
        },
        {
          property: 'og:title',
          content: 'Forgot Password | Dotlines'
        }
      ],
    }
  },
  data: () => ({
    user: {},
    is_loading: false
  }),
  methods: {
    forget_pass: function (e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let api_url = this.API_BASE_URL + '/auth/forgot-password';
          let token = '';
          let _this = this;
          _this.is_loading = true;
          // return;
          axios({
            method: 'post',
            url: api_url,
            data: _this.user
          }).then(function (response) {
            console.log(":::::::Response::::::", response);
            if (response.status === 200 && response.data.otp_success === true) {
             // _this.$toaster.success(response.data.message);
              _this.user.email = '';
              $(".response-alert").html("").prepend($(
                '<div class="help text-success">\n' +
                  response.data.message +
                '</div>'));
             // _this.$router.push({name: 'ResetPass', params: {userInfo: response.data}});
            }else if(response.status === 200 && response.data.otp_success === false){
              //_this.$toaster.error(response.data.message,{toastClassName: ['error-message'], bodyClassName:['error-message'], timeout: 98000});
              $(".response-alert").html("").prepend($(
                '<div class="help text-danger">\n' +
                  response.data.message +
                '</div>'));
            } else {

              $(".response-alert").prepend($(
                '<div class="help text-danger">\n' +
                  'Sorry the email you entered is not valid/registered. Please try with correct email' +
                '</div>'));

            }
          }).catch(function (error) {
            if (error.response) {
            
              if(error.response.status === 429 ){
                 // Too many request from an ip
                 const msg = error.response.data.message;
                  $(".response-alert").html("").prepend($(
                      '<div class="help text-danger">\n' +
                            msg +
                      '</div>'));
              }else{        
                // const msg = error.response.data.message;        
                const msg = error.response.data.errors?.email || "";
                console.log(msg);
                  $(".response-alert").html("").prepend($(
                      '<div class="help text-danger">\n' +
                            msg +
                      '</div>'));
              }
     
            } else if (error.request) {
              // The request was made but no response was received
              console.log("Error", error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }

          }).finally(function () {
            _this.is_loading = false;
            _this.is_disabled = false;
            setTimeout(() => {
              $('.alert').fadeOut('slow');
            }, 5000);
          });

          console.warn(this.user)
        }
      });
    },

  },
  mounted: function () {
    // localStorage.setItem("authenticate", false);
    // localStorage.removeItem("token");
  },
  created() {
    this.$emit('update:layout', GuestLayout)
  }
}
</script>
